import React from 'react';
import { Button, useTheme } from '@mui/material';
import { buttonStyles, glowKeyframes } from './cityCard.styles';

const CityCard = ({ city }) => {
  const theme = useTheme();

  return (
    <>
      <style>{glowKeyframes}</style>
      <Button sx={buttonStyles(theme)}>
        {city?.name.toUpperCase()}
      </Button>
    </>
  );
};

export default CityCard;